import React from 'react';
import { useNavigate } from 'react-router-dom';

function ViopPage() {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-gray-50">
      <header className="bg-[#1e5a8e] py-6 px-4 shadow-md">
        <div className="max-w-7xl mx-auto flex items-center justify-between">
          <button onClick={() => navigate('/')} className="text-white hover:text-[#26c6da] transition-colors">
            <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" />
            </svg>
          </button>
          <h1 className="text-2xl md:text-3xl font-bold text-white">VİOP</h1>
          <div className="w-6"></div>
        </div>
      </header>

      <div className="max-w-6xl mx-auto py-12 px-4">
        <div className="bg-gradient-to-br from-[#1e5a8e] to-[#26c6da] rounded-lg shadow-lg p-12 text-white mb-8">
          <h2 className="text-4xl font-bold mb-4">VİOP - Vadeli İşlem ve Opsiyon Piyasası</h2>
          <p className="text-xl opacity-90">
            35 yıllık tecrübemizi teknolojiye uyumlu hale getirip, kişiye özel hizmet sunuyoruz.
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-8 mb-8">
          <div className="bg-white rounded-lg shadow-md p-8">
            <h3 className="text-2xl font-bold text-[#1e5a8e] mb-4">VİOP Nedir?</h3>
            <p className="text-gray-600 leading-relaxed mb-4">
              Vadeli İşlem ve Opsiyon Piyasası, gelecekteki bir tarihte belirli bir fiyattan 
              alım veya satım yapma hakkı veren finansal araçların işlem gördüğü piyasadır.
            </p>
            <ul className="space-y-2 text-gray-600">
              <li>✓ Endeks Vadeli İşlemleri</li>
              <li>✓ Hisse Senedi Vadeli İşlemleri</li>
              <li>✓ Döviz Vadeli İşlemleri</li>
              <li>✓ Emtia Vadeli İşlemleri</li>
            </ul>
          </div>

          <div className="bg-white rounded-lg shadow-md p-8">
            <h3 className="text-2xl font-bold text-[#1e5a8e] mb-4">VİOP Avantajları</h3>
            <div className="space-y-4">
              <div className="flex gap-3">
                <div className="text-[#26c6da] text-2xl">⚡</div>
                <div>
                  <h4 className="font-bold text-gray-800">Kaldıraç Etkisi</h4>
                  <p className="text-gray-600 text-sm">Düşük teminatla büyük pozisyonlar</p>
                </div>
              </div>
              <div className="flex gap-3">
                <div className="text-[#26c6da] text-2xl">🛡️</div>
                <div>
                  <h4 className="font-bold text-gray-800">Riskten Korunma</h4>
                  <p className="text-gray-600 text-sm">Portföyünüzü koruyun</p>
                </div>
              </div>
              <div className="flex gap-3">
                <div className="text-[#26c6da] text-2xl">🔄</div>
                <div>
                  <h4 className="font-bold text-gray-800">İki Yönlü İşlem</h4>
                  <p className="text-gray-600 text-sm">Yükselişte ve düşüşte kazanç</p>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="bg-white rounded-lg shadow-md p-8">
          <h3 className="text-2xl font-bold text-[#1e5a8e] mb-6">VİOP Algoritmalar</h3>
          <p className="text-gray-600 mb-6">
            Risk tercihlerinize göre özelleştirilen algoritmalar ile ekran başında olmadan yatırım yapın.
          </p>
          <button 
            onClick={() => navigate('/login')}
            className="px-8 py-3 bg-[#26c6da] text-white rounded-lg font-semibold hover:bg-[#1ea8c1] transition-colors"
          >
            Hemen Başla
          </button>
        </div>
      </div>
    </div>
  );
}

export default ViopPage;
